import { render, staticRenderFns } from "./ModalVerificacaoAcao.vue?vue&type=template&id=66543b9f&scoped=true&"
import script from "./ModalVerificacaoAcao.vue?vue&type=script&lang=js&"
export * from "./ModalVerificacaoAcao.vue?vue&type=script&lang=js&"
import style0 from "./ModalVerificacaoAcao.vue?vue&type=style&index=0&id=66543b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66543b9f",
  null
  
)

export default component.exports